import React from "react";
import { Navigate, useParams } from "react-router-dom";
import Match from "../../components/Match";
import { allowedViews, pathHome, pathMatchView, type View } from "../../../config/routes";


const isAllowedView = (v?: string): v is View =>
  !!v && allowedViews.includes(v as View);

const MatchPage: React.FC = () => {
  const { matchId: matchIdParam, view: viewParam } = useParams<{
    matchId?: string;
    view?: string;
  }>();

  const matchId = React.useMemo(() => {
    const n = matchIdParam ? parseInt(matchIdParam, 10) : NaN;
    return Number.isFinite(n) ? n : undefined;
  }, [matchIdParam]);

  const view: View | undefined = React.useMemo(
    () => (isAllowedView(viewParam) ? (viewParam as View) : undefined),
    [viewParam]
  );


  if (typeof matchId !== "number") {
    return <Navigate to={pathHome()} replace />;
  }

  if (!view) {
    return <Navigate to={pathMatchView(matchId, "highlights")} replace />;
  }

  return <Match matchId={matchId} currentView={view} />;
};

export default MatchPage;
